import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './Store';
import { BrowserRouter as Router } from 'react-router-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import './i18n'; // i18n configuration

console.log = function () {};

ReactDOM.render(
	<Provider store={store}>
		<MuiPickersUtilsProvider utils={MomentUtils}>
			<Router>
				<App />
			</Router>
		</MuiPickersUtilsProvider>
	</Provider>,
	document.getElementById('root'),
);
